/**
 * constants/company.ts · 公司信息抽出 (SaaS 租户化预备)
 *
 * v362.1 · 2026-05-27 · 从 Jack 上传 PDF (09.09.2025 THÔNG TIN CÔNG TY)
 *   提取真实数据替换所有 XXX 占位符 · 让单据打印用真数据
 *
 * 当前: 硬编 TRUNG NAM 越南中南纸业责任有限公司
 * 未来: SaaS 销售时改读 tenant config (替代硬编码)
 *
 * SHOULD_ABSTRACT: 多租户时从 D1 tenants 表动态加载
 *
 * 来源: 09.09.2025 公司变更地址 + 银行账户官方文件 (盖公章签字版)
 */

export const TN_COMPANY = {
  name: {
    zh: '越南中南纸业责任有限公司',
    vi: 'CÔNG TY TNHH GIẤY TRUNG NAM VIỆT NAM',
    en: 'TRUNG NAM VIET NAM PAPER COMPANY LIMITED',
  },
  shortName: 'TRUNG NAM',
  /** MST 越南税号 (真实, 09.09.2025 注册) */
  taxId: '3702735191',
  /** 注册地址 (09.09.2025 变更后) · KCN Tân Bình · HCMC */
  address: {
    zh: '越南胡志明市永新区新平工业园区 2D2 · CN7、CN10 路 1 号工厂',
    vi: 'Nhà xưởng số 1, Lô 2D2, Đường CN7 và CN10, KCN Tân Bình, Phường Vĩnh Tân, Thành phố Hồ Chí Minh, Việt Nam',
    en: 'Lot 2D2, Road CN7 & CN10, Tan Binh Industrial Park, Vinh Tan Ward, Ho Chi Minh City, Viet Nam',
  },
  /** 公司电话 (Bình Dương landline · 不含国家码 +84) */
  phone: '02743-990-178',
  /** 公司邮箱 (Jack 内部用 · 抬头展示 · v300 后可改 office@) */
  email: 'jack.zhu@tg-packaging.com',
  /** 法人代表 · Đại diện pháp luật · Legal Representative (注册业务执照上的姓名) */
  legalRepresentative: 'ZHU LI CHENG · 朱立成',
  /** 银行账户 (BIDV 美福分行) */
  bankAccount: {
    bank: 'BIDV',
    bankFull: {
      zh: '越南投资发展银行 BIDV · 美福分行',
      vi: 'Ngân hàng TMCP Đầu tư và Phát triển Việt Nam (BIDV) - Chi nhánh Mỹ Phước',
      en: 'Bank for Investment and Development of Vietnam (BIDV) - My Phuoc Branch',
    },
    bankAddress: {
      zh: '越南胡志明市槟吉坊美福 II 工业区',
      vi: 'KCN Mỹ Phước 2, Phường Bến Cát, Thành phố Hồ Chí Minh, Việt Nam',
      en: 'My Phuoc II Industrial Park, Ben Cat Ward, Ho Chi Minh City, Viet Nam',
    },
    /** VND 账号 (本地客户付款) */
    accountNoVnd: '6521295397',
    /** USD 账号 (国际客户/Costco 付款) */
    accountNoUsd: '6520012144',
    /** 兼容旧字段名 (默认显 VND) */
    accountNo: '6521295397',
    swift: 'BIDVVNVX',
    swift11: 'BIDVVNVXXXX',
  },
  industry: '瓦楞纸箱包装 · Bao bì giấy carton sóng · Corrugated Paper Packaging',
  founded: 2018,
} as const;

/** SaaS 多语种支持 · 未来扩泰国/印尼/马来 */
export const SUPPORTED_LANGUAGES = ['zh', 'vi'] as const;
export type SupportedLanguage = typeof SUPPORTED_LANGUAGES[number];

/**
 * 当前 v18.9.x 版本 · 🔥 唯一事实源 (Single Source of Truth)
 *
 * R12 严守: 任何 UI / log / report 显示版本号 必须 import APP_VERSION
 * 永不 hardcode 字符串 "v18.9.xxx" · 防 stale (历史教训: 7 处 stale 同时存在)
 *
 * Bump 步骤:
 *   1. 这里改 (唯一字符串源)
 *   2. package.json version (npm + GitHub Actions 用)
 *   3. 写 docs/VXXX-REPORT.md
 *   4. CLAUDE.md 累计累计后写入 (历史)
 */
export const APP_VERSION = '18.9.365.2';
export const APP_NAME = 'Trungnam MES PRO';
